module.exports = __webpack_public_path__ + "static/media/commission_2.7c0cffe7.svg";